import React, { useEffect } from "react";
import "./App.css";
import { useLocation } from "react-router-dom";
import bgLogin from "./assets/img/bg-login.png";
import bgContent from "./assets/img/bg-content.png";
import { AuthProvider } from "./contexts/AuthProvider";
import MainMenu from "./layouts/mainMenu/MainMenu";

function App() {
  const location = useLocation();
  if (
    location.pathname === "/tax-declaration/message-confirmation" ||
    location.pathname === "/tax-dispute/message-confirmation" ||
    location.pathname === "/login" ||
    location.pathname === "/forget-password" ||
    location.pathname === "/forget-password-phone" ||
    location.pathname === "/new-password"
  ) {
    document.body.style.backgroundImage = `url(${bgLogin})`;
  } else if (
    location.pathname === "/home" ||
    location.pathname === "/" ||
    location.pathname === "/online-payment/realestate-payment" ||
    location.pathname === "/online-payment/electronic-payment"
  ) {
    document.body.style.backgroundImage = "none";
  } else {
    document.body.style.backgroundImage = `url(${bgContent})`;
  }
  return (
    <div className="App">
      <AuthProvider>
        <MainMenu />
      </AuthProvider>
    </div>
  );
}

export default App;
